import React from 'react';
import { Box } from '@mui/material';

interface LoaderProps {
    isOpen?: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ isOpen = true }) => {
    if (!isOpen) return null;
    return (
        <Box id="loader-app">
            <img src="/loader.svg" alt="Завантаження..." className="spinner-icon" />
        </Box>
    );
};

export default Loader;
